import { useCallback, useMemo } from 'react';
import { compareAsc, isAfter } from 'date-fns';
import type { WorkHoursInterval } from '../../common/business-hours-types';
import { useUpcomingDays } from './use-upcoming-days';

export function useUpcomingWorkHoursIntervals(): (
  givenDate: Date
) => WorkHoursInterval {
  const upcomingDays = useUpcomingDays();

  const upcomingHours = useMemo(() => {
    return upcomingDays
      .sort((a, b) => compareAsc(a.date, b.date))
      .filter(({ isClosed, hours }) => {
        return !isClosed && hours.length > 0;
      })
      .flatMap(({ hours }) => hours);
  }, [upcomingDays]);

  return useCallback(
    (givenDate) =>
      upcomingHours.filter(([, end]) => isAfter(end, givenDate))[0],
    [upcomingHours]
  );
}
